import {Component} from '@angular/core';
import {Response, Headers, RequestOptions, Http} from '@angular/http';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';
import { environment } from 'environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-parking-passes-detailed-view',
    templateUrl: './settings-parking-passes-detailed-view.component.html',
    styleUrls: ['./settings-parking-passes-detailed-view.component.scss']
})

export class SettingsParkingPassesDetailedViewComponent {
    title = 'Resident';
    disabledFileInput = false;
    navPosition = 'general';
    attachments: Array<any> = [];
    timeIntervals = [
        {name: 'min', displayName: 'Minute'},
        {name: 'hour', displayName: 'Hour'},
        {name: 'day', displayName: 'Day'},
        {name: 'week', displayName: 'Week'},
        {name: 'month', displayName: 'Month'},
        {name: 'year', displayName: 'Year'}
    ];
    timeIntervalsPer = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];
    noEdit = false;

    constructor(
      public api: ApiClientService,
      public settingsParkingPassesService: SettingsParkingPassesService,
      public directoryService: DirectoryService,
      private authTokenService: AuthTokenService,
      private http: Http
    ) {}

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `${this.settingsParkingPassesService.parkingPassesData[this.settingsParkingPassesService.currentTabId].patch}${this.settingsParkingPassesService.selectedItemData.id}.json`;
        this.settingsParkingPassesService.api.patch('domainParkingPass', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => {
                this.api.errorHandler(error);
                if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.filter( error => toastr.error(error.description) );
                else
                    toastr.error('Update failed!');
            },
            () => { this.noEdit = false; }
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.settingsParkingPassesService.toggleDetailedView(this.settingsParkingPassesService.selectedItemData, true);
        this.settingsParkingPassesService.getData();
        if (close) this.settingsParkingPassesService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for (const field in this.settingsParkingPassesService.selectedItemData.formFields) this.settingsParkingPassesService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    onRestrictionsFieldSubmit(number, selectValue, field): void {
        let data = {};
        if(field == 'minIntervalBetweenBooking') {
            data = {
                minIntervalBetweenBooking: number && selectValue ? (number + ' ' + selectValue) : ''
            };
        } else if(field == 'maxBookingsPerSuiteCount') {
            data = {
                maxBookingsPerSuiteCount: number,
                maxBookingsPerSuiteSequenceType: selectValue
            };
        } else if(field == 'maxBookingsPerLicensePlate') {
            data = {
                maxBookingsPerLicensePlateCount: number,
                maxBookingsPerLicensePlateSequenceType: selectValue
            };
        }

        this.onSubmit(data);
    }

    addImage(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 1000000) {
            toastr.warning('Maximum image size is 1MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.settingsParkingPassesService.modalSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainAmenities}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Image path should not be blank.');
                    return;
                }
                this.settingsParkingPassesService.selectedItemData.amenityImage = res.path;
                this.onSubmit({amenityImage: this.settingsParkingPassesService.selectedItemData.amenityImage});
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => {
                this.settingsParkingPassesService.modalSpinnerShow = false;
                this.disabledFileInput = false;
            }
        );
    }

    buildingParkingPassLotsFormatConvertion(buildings): any {
        return buildings.filter((b) => ({
                   buildingId: b.id,
                   buildingName: this.getBuildingNameById(b.id),
                   timezone: b.timeZone
               }));
    }

    parkingPassLotsFormatConvertion(lots): any {
        return lots.map((l) => ({parkingLot: l.id}));
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsParkingPassesService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    showNotificationModal(staffOrResident, notificationType): void {
        this.settingsParkingPassesService.isPassNotificationModalShow = true;
        this.settingsParkingPassesService.passNotificationModalStaffOrResident = staffOrResident;
        this.settingsParkingPassesService.passNotificationModalNotificationType = notificationType;
    }

    isRestrictionsStringValid(string): boolean {
        return string && Number.isInteger(+string.substr(0, 1));
    }

    submitNotificationsField(): void {
        const data = {
            staffNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsParkingPassesService.passCreatedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParkingPassesService['createdStaffMultiselectArray'])
                },
                {
                    action: 'approved',
                    enableStatus: this.settingsParkingPassesService.passApprovedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParkingPassesService['approvedStaffMultiselectArray'])
                },
                {
                    action: 'declined',
                    enableStatus: this.settingsParkingPassesService.passDeclinedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParkingPassesService['declinedStaffMultiselectArray'])
                },
                {
                    action: 'request',
                    enableStatus: this.settingsParkingPassesService.passRequestStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParkingPassesService['requestStaffMultiselectArray'])
                }
            ],
            residentsNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsParkingPassesService.passCreatedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'approved',
                    enableStatus: this.settingsParkingPassesService.passApprovedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'declined',
                    enableStatus: this.settingsParkingPassesService.passDeclinedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'request',
                    enableStatus: this.settingsParkingPassesService.passRequestResidentCheckbox ? 1 : 0
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    deleteSelected(): void {
        if(this.settingsParkingPassesService.currentTabId == 'lots')
            this.settingsParkingPassesService.deleteParkingLot(this.settingsParkingPassesService.selectedItemData);
        else if(this.settingsParkingPassesService.currentTabId == 'rules')
        this.settingsParkingPassesService.deleteParkingRule(this.settingsParkingPassesService.selectedItemData);
    }

    paymentMethodSubmit(data): void {
        const check = {
            acceptCash : false,
            acceptCheques : false,
            acceptCreditCards: false
        };
        check.acceptCash = this.settingsParkingPassesService.selectedItemData.acceptCash;
        check.acceptCheques = this.settingsParkingPassesService.selectedItemData.acceptCheques;
        check.acceptCreditCards = this.settingsParkingPassesService.selectedItemData.acceptCreditCards;
        check[Object.keys(data)[0]] = data[Object.keys(data)[0]];
        if(!check.acceptCash && !check.acceptCheques && !check.acceptCreditCards)
            data.defaultPaymentMethod = '';
        if(this.settingsParkingPassesService.selectedItemData.defaultPaymentMethod == 'credit_card' &&
            data.acceptCreditCards === 0)
            data.defaultPaymentMethod = '';
        if(this.settingsParkingPassesService.selectedItemData.defaultPaymentMethod == 'cheque' &&
            data.acceptCheques === 0)
            data.defaultPaymentMethod = '';
        if(this.settingsParkingPassesService.selectedItemData.defaultPaymentMethod == 'cash' &&
            data.acceptCash === 0)
            data.defaultPaymentMethod = '';
        this.onSubmit(data);
    }

    ifAnyPassTypeHasFee(): boolean {
        let flag = false;
        if(this.settingsParkingPassesService.selectedItemData &&
           this.settingsParkingPassesService.selectedItemData.passTypes &&
           this.settingsParkingPassesService.selectedItemData.passTypes.length > 0) {
            this.settingsParkingPassesService.selectedItemData.passTypes.forEach((type) => {
                if(type.fee && type.feeEnabledStatus)
                    flag = true;
            });
        }
        return flag;
    }

    showPassTypeModal(passType?): void {
        this.settingsParkingPassesService.isPassTypeModalShow = true;
        if(passType)
            this.settingsParkingPassesService.passTypeInPassTypeModal = passType;
    }

    changePassTypeEnabledStatus(id, status): void {
        let updatedPassTypesArray = [];
        this.settingsParkingPassesService.selectedItemData.passTypes.forEach((type) => {
            if(type.id == id)
                updatedPassTypesArray.push({name: type.name, enableStatus: status});
            else
                updatedPassTypesArray.push({name: type.name});
        });
        this.onSubmit({passTypes: updatedPassTypesArray});
    }

    deletePassType(event, type): void {
        event.stopPropagation();
        swal(ConstantsService.getSwalConfig('Delete Pass Type?', 'Are you sure that you want to delete the pass type?'),
            () => {
                let modifiedPassTypeArray = [];
                this.settingsParkingPassesService.selectedItemData.passTypes.filter((passType) => {
                    if (type.id != passType.id) {
                        const tempType = JSON.parse(JSON.stringify(passType));
                        tempType.passTypeSchedule.startTime = this.settingsParkingPassesService.getTimeFromDateToString(tempType.passTypeSchedule.startTime);
                        tempType.passTypeSchedule.endTime = this.settingsParkingPassesService.getTimeFromDateToString(tempType.passTypeSchedule.endTime);
                        delete tempType.id;
                        modifiedPassTypeArray.push(tempType);
                    }
                });
                this.onSubmit({passTypes: modifiedPassTypeArray});
            }
        );
    }

    public validateValue(event) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    public addLimitGroup() {
        this.settingsParkingPassesService.selectedItemData.limitGroups.push({
            limitCount: null,
            limitSequenceType: '',
            limitedPassTypes: []
        });
    }

    public submitLimitGroups() {
        const limitGroupsForSending = this.settingsParkingPassesService.selectedItemData.limitGroups.map(group => ({
            limitCount: group.limitCount,
            limitSequenceType: group.limitSequenceType,
            limitedPassTypes: group.limitedPassTypes.map( limitPass => ( limitPass.id ) )
        }));

        this.onSubmit({ limitGroups: limitGroupsForSending });
    }

    public removeLimitGroup(index) {
        this.settingsParkingPassesService.selectedItemData.limitGroups.splice(index, 1);
        this.submitLimitGroups();
    }

    emailTemplateIsSet(type, action) {
        let flag = false;
        this.settingsParkingPassesService.selectedItemData[type + 'NotificationSettings'].filter((setting) => {
            if(setting.action == action)
                flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
        });
        return flag;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes-detailed-view/settings-parking-passes-detailed-view.component.ts